import styled from 'styled-components';
import { TextArea } from 'ui/inputs';
import { SecondaryButton } from 'ui/button';
import { WarningBanner } from 'ui/banner';
import { RightTooltip } from 'ui/tooltip';
import { FormField } from 'ui/formField';
import { colors, fontSizes, spacing } from 'ui/theme';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const StyledFormField = styled(FormField)<{ isDisabled?: boolean }>`
  [data-test='form-field-header'] > label {
    font-size: ${fontSizes.s16};
  }

  ${({ isDisabled }) => isDisabled && `color: ${colors.textSecondary};`}
`;

export const RadioFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.threeQuarter};
`;

export const FieldTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
`;

export const RadioOption = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const FrequencyDisclaimer = styled.span`
  color: ${colors.textSecondary};
`;

export const RestrictionText = styled.span`
  display: flex;
  align-items: baseline;
  gap: ${spacing.half};
`;

export const UndoButton = styled(SecondaryButton)`
  padding: 0 ${spacing.quarter};
`;

export const OptOutTextArea = styled(TextArea)`
  background: ${colors.white};
  cursor: default;
`;

export const StyledWarningBanner = styled(WarningBanner)`
  margin-top: ${spacing.plusHalf};
`;

export const DisabledTooltip = styled(RightTooltip)`
  cursor: not-allowed;
`;
